<template>
  <card>
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "business",
      fields: [
        {
          key: "first_name",
          label: "Имя",
          type: "field",
          textType: "text",
          readonly: false,
        },
        {
          key: "last_name",
          label: "Фамилия",
          type: "field",
          textType: "text",
          readonly: false,
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_author",
      itemLink: "authors",
      setLink: "authors",
      columns: [
        {
          key: "last_name",
          title: "Фамилия",
        },
        {
          key: "first_name",
          title: "Имя",
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
